import { Wallet, TrendingUp, LineChart, Scale } from "lucide-react";
import { Container, PageHero, SectionLabel, CtaBand } from "./_ui";
import { Seo } from "@/components/marketing/Seo";

const STATS = [
  { label: "Bankinnskudd · august", value: "1 799 493 kr", delta: "+15,9 % mot i fjor" },
  { label: "Omsetning hittil i år", value: "4 250 933 kr", delta: "+9 % mot i fjor" },
  { label: "Driftsresultat · august", value: "926 723 kr", delta: "+21 % mot i fjor" },
  { label: "Driftsmargin · august", value: "21,8 %", delta: "+2,8 % mot i fjor" },
];

const REPORTS = [
  { icon: Wallet, title: "Banksaldo", desc: "Daglig oppdatert saldo per selskap, med utvikling måned for måned." },
  { icon: TrendingUp, title: "Resultat og margin", desc: "Omsetning, driftsresultat og margin sammenlignet mot samme periode i fjor." },
  { icon: LineChart, title: "Likviditetsprognose", desc: "Se hvordan kontantstrømmen utvikler seg før styret fatter vedtak." },
  { icon: Scale, title: "Balanse og statistikk", desc: "Balanserapporter og porteføljestatistikk samlet i én visning." },
];

const INTEGRATIONS = ["Tripletex", "Fiken", "PowerOffice", "Brønnøysundregistrene", "Proff", "Altinn"];

export default function Nokkeltall() {
  return (
    <>
      <Seo title="Nøkkeltall og rapportering" description="Bankinnskudd, omsetning, driftsresultat og margin hentes automatisk fra Tripletex, Fiken og PowerOffice til hvert styremøte." path="/nokkeltall" />
      <PageHero label="Nøkkeltall" title="Ferske tall til hvert eneste styremøte.">
        Koble styrerommet til Tripletex, Fiken eller PowerOffice, og få bankinnskudd, omsetning, driftsresultat og margin oppdatert automatisk — for hvert selskap og for hele porteføljen.
      </PageHero>

      <Container className="pb-6">
        <p className="text-sm text-neutral-500">Data lagres i Norge og deles kun med styret.</p>
      </Container>

      <Container className="py-10">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s) => (
            <div key={s.label} className="rounded-2xl border border-neutral-200 p-6">
              <p className="text-xs text-neutral-500">{s.label}</p>
              <p className="mt-3 font-headings text-2xl font-extrabold tracking-tight text-neutral-900">{s.value}</p>
              <p className="mt-1 text-xs font-medium text-emerald-600">{s.delta}</p>
            </div>
          ))}
        </div>
      </Container>

      <Container className="py-12 sm:py-16">
        <h2 className="max-w-2xl font-headings text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl">Rapportene styret faktisk bruker.</h2>
        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {REPORTS.map((r) => (
            <div key={r.title} className="rounded-2xl border border-neutral-200 p-7">
              <div className="grid h-11 w-11 place-items-center rounded-xl bg-[#CDF546]"><r.icon className="h-5 w-5 text-neutral-900" strokeWidth={1.9} /></div>
              <h3 className="mt-5 font-headings text-lg font-bold text-neutral-900">{r.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-600">{r.desc}</p>
            </div>
          ))}
        </div>
      </Container>

      <Container className="py-12 sm:py-16">
        <SectionLabel>Integrasjoner</SectionLabel>
        <h2 className="mt-4 max-w-2xl font-headings text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl">
          Én kobling mot regnskapet — resten går av seg selv.
        </h2>
        <div className="mt-8 flex flex-wrap gap-3">
          {INTEGRATIONS.map((i) => (
            <span key={i} className="rounded-full border border-neutral-200 px-5 py-2.5 text-sm font-medium text-neutral-700">{i}</span>
          ))}
        </div>
      </Container>

      <CtaBand title="Vil du se tallene for dine egne selskaper?" />
    </>
  );
}
